import {get, post} from "../app/ApiManger";

class AuthService {
    static async login({username, password}) {
        const response = await post({
            path: "auth/admin/login",
            reqBody: {
                username,
                password,
            }
        })
        return response;
    }

    static async getUserDetails(token) {
        return get({
            path: "auth/admin/me",
            header: {
                Authorization: `Bearer ${token}`,
            },
        })
    }

    static async logout(token) {
        return post({
            path: "auth/admin/logout",
            response: {
                token
            }
        })
    }

}

export default AuthService;